import React from 'react'
import { useMutation } from 'react-query'
import axios, { AxiosError } from 'axios'
import { getAppConfigSetting } from '../utils'
import { SENTINEL_API } from './constants'
import { useToast } from '@chakra-ui/react'
import { Alert, useAlert } from '@apex/component-library'
import { SERVICE_UNAVAILABLE_TOAST, TOTAL_TRANSFER_SUCCESS_TOAST, TRANSFER_SUCCESS_TOAST } from '../constants'
// TODO: Replace with ui-components toast

export type TransferDirection = 'deposits' | 'withdrawals'
const achSubmissionURL = (direction: TransferDirection) =>
  `${getAppConfigSetting('apiUrl')}${SENTINEL_API}/transfers/achs/${direction}`

export const postACHSubmission = (direction: TransferDirection) => async (payload: {}) => {
  const { data } = await axios.post(achSubmissionURL(direction), payload, {
    withCredentials: true
  })
  return data
}

interface Options {
  onMutate?: Function
  onError?: Function
  onSuccess?: Function
  onSettled?: Function
  amountAvailable?: number
  isFullDisbursement?: boolean
  amount?: number
}

export default function useAchSubmission(direction: TransferDirection, options?: Options) {
  const { onMutate, onError, onSuccess, onSettled, amountAvailable, isFullDisbursement, amount } = options || {}
  const toast = useToast()
  const { setAlert } = useAlert()
  return useMutation(postACHSubmission(direction), {
    onMutate: (variables) => {
      // Do stuff before post call
      onMutate && onMutate()
    },
    onError: (error: AxiosError, variables, context) => {
      if (error.response?.status && error.response.status >= 400 && error.response.status < 500) {
        toast({
          position: 'top-right',
          variant: 'left-accent',
          isClosable: true,
          title: 'The request failed.',
          description: `${error.response.data.errorDescription}`,
          status: 'error',
          duration: null,
          render: ({ onClose, id }) => (
            <Alert
              sx={{
                width: 340,
                color: 'black',
                bg: 'white',
                boxShadow: '0px 0px 5px 3px rgba(153,153,153,0.5)'
              }}
              direction='column'
              variant='left-accent'
              title='The request failed.'
              description={`${error?.response?.data?.errorDescription}`}
              status='error'
              isClosable
              dismiss={onClose}
              id={id as string}
            />
          )
        })
      } else {
        setAlert({
          direction: 'row',
          variant: 'left-accent',
          title: 'System Unavailable',
          description: SERVICE_UNAVAILABLE_TOAST,
          status: 'error',
          isClosable: true
        })
      }
      onError && onError()
    },
    onSuccess: (data, variables, context) => {
      const description =
        isFullDisbursement || amountAvailable === amount ? TOTAL_TRANSFER_SUCCESS_TOAST : TRANSFER_SUCCESS_TOAST
      toast({
        duration: 5000,
        position: 'top-right',
        title: 'Success!',
        variant: 'left-accent',
        description: description,
        status: 'success',
        isClosable: true,
        render: ({ onClose, id }) => (
          <Alert
            sx={{
              width: 340,
              color: 'black',
              bg: 'white',
              boxShadow: '0px 0px 5px 3px rgba(153,153,153,0.5)'
            }}
            direction='column'
            variant='left-accent'
            title='Success!'
            description={description}
            status='success'
            isClosable
            dismiss={onClose}
            id={id as string}
          />
        )
      })
      onSuccess && onSuccess()
    },
    onSettled: (data, error, variables, context) => {
      // do stuff after Error or success.
      onSettled && onSettled()
    }
  })
}
